import mj_anagrafica_utils from "@/misc/mj_anagrafica_utils.js"

var validationRulesMixin = {
  data: () => ({
    rules: {
      required: value => !!value || "Campo Obbligatorio",
      must_be_true: value => true == value || "Accettazione obbligatoria",
      alphanumeric: value => {
        const pattern = /^\w+$/
        return (value == null || value === "" || pattern.test(value)) || "Inserisci solo caratteri alfanumerici o underscore";
      },
      letters: value => {
        const pattern = /^[A-Za-z]+$/
        return (value == null || value === "" || pattern.test(value)) || "Inserisci solo lettere";
      },
      integer: value => {
        const pattern = /^-?\d+$/
        return (value == null || value === "" || pattern.test(value)) || "Inserisci un Numero Intero";
      },
      float: value => {
        //TODO - quella sotto è solo un copia e incolla di integer.
        const pattern = /^-?\d+$/
        return (value == null || value === "" || pattern.test(value)) || "Inserisci un Numero Decimale";
      },
      piva: value => {
        //non valido se il valore non è presente (uso required se devo mettere questa regola)
        if (value && value.length > 0) {
          const resp = mj_anagrafica_utils.validatePIva(value);
          return (resp && resp.code > 0) ? true : resp.message;
        }
        else { return true; }
      },
      cf: value => {
        //non valido se il valore non è presente (uso required se devo mettere questa regola)
        if (value && value.length > 0) {
          const resp = mj_anagrafica_utils.validateCF(value);
          return (resp && resp.code > 0) ? true : resp.message;
        }
        else { return true; }
      },
      email: value => {
        //non valido se il valore non è presente (uso required se devo mettere questa regola)
        if (value && value.length > 0) {
          const resp = mj_anagrafica_utils.validateEmail(value);
          return (resp && resp.code > 0) ? true : resp.message;
        }
        else { return true; }
      },
      max(maxNum) {
        return v => (v || '').length <= maxNum || 'Numero massimo di caratteri superato';
      }
    }
  })
};

export default validationRulesMixin;
